import type { AxiosResponse } from "axios";

import { getData, postData } from "@/apis/apiInstance";

import type {
  assignGroupToUserType,
  CreateMenuPayloadType,
  CreateUserGroupType,
  GetAllUserGroupPayloadType,
  GetAllUsersToGroupDetailsPayloadType,
  getAssignedGroupToUserPayloadType,
  GetSingleUserGroupDetailsType,
  UpdateUserGroupType,
} from "@/commonTypes/userManagementTypes";

import { getCSRFToken } from "@/utils/commonFunctions";

export async function getAllMenuListApi(
  token: string | null
): Promise<AxiosResponse> {
  return await getData(`menu/list`, {
    params: {
      offset: 1,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createUserGroupApi(
  data: CreateUserGroupType
): Promise<AxiosResponse> {
  const { token, menu_map_id, group_name } = data;

  return await postData(
    `group/menu/create`,
    { menu_map_id, group_name },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateUserGroupApi(
  data: UpdateUserGroupType
): Promise<AxiosResponse> {
  const { token, group_id, group_name, menu_map_id } = data;

  return await postData(
    `group/menu/update`,
    { group_id, group_name, menu_map_id },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getAllUserGroupsApi(
  data: GetAllUserGroupPayloadType
): Promise<AxiosResponse> {
  const { token, offset, limit, search_term } = data;
  return await getData(`group/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      limit,
      offset,
      search_term,
    },
  });
}

export async function getSingleUserGroupDetailsApi(
  data: GetSingleUserGroupDetailsType
): Promise<AxiosResponse> {
  const { token, group_id } = data;

  return getData(`group/menu/list`, {
    params: {
      group_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function assignUsergroupToUserApi(
  data: assignGroupToUserType
): Promise<AxiosResponse> {
  const { token, user_id, group_id } = data;
  let finalData = {
    user_id: [user_id],
    group_id,
  };

  return await postData(`user/group/map`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAssignedGroupToUserApi(
  data: getAssignedGroupToUserPayloadType
): Promise<AxiosResponse> {
  let { limit, offset, search_term, token } = data;

  return getData(`finac/user-group/mapping-list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      limit,
      offset,
      ...(search_term && { search_term }),
    },
  });
}
// new Assign group to user
export async function getAssignedUsersToGroupApi(
  data: GetAllUsersToGroupDetailsPayloadType
): Promise<AxiosResponse> {
  let { token, limit, offset, group_id } = data;
  return getData(`user/group/map-list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      limit,
      offset,
      group_id,
    },
  });
}

export async function assignUserToGroupApi(
  data: assignGroupToUserType
): Promise<AxiosResponse> {
  const { token, group_id, user_id } = data;
  return await postData(
    `user/group/map`,
    { group_id, user_id },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

//=========================================================
export async function createMenuApi(
  data: CreateMenuPayloadType
): Promise<AxiosResponse> {
  const { token } = data;

  return await postData(
    `menu/create`,
    { ...data },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateMenuApi(
  data: CreateMenuPayloadType
): Promise<AxiosResponse> {
  const { token } = data;
  return await postData(
    `menu/update`,
    { ...data },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
